import Fetch from '../../common/fetch'
import Storage from '../../common/storage'
import Tool from '../../common/tool'
import {
  Toast,
  Indicator
} from 'mint-ui'

// 查询商圈
function loadBusinessSearchReq(bizcycle, completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }

  var options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    bizcycle: bizcycle
  }
  Indicator.open('加载中...')
  Fetch.loadBusinessSearch(options).then((resp) => {
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data, 'Success')
    } else if (resp.code === 10) {
      if (resp.data.guess === undefined) {
        completion(null, 'NotFound')
      } else {
        completion(resp.data, 'Guess')
      }
    }
  }).catch((resp) => {
    Indicator.close()
    console.log(resp)
  })
}

// 查询小区
function loadCommunitySearchReq(community, completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }

  var options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    community: community
  }
  Indicator.open('加载中...')
  Fetch.loadCommunitySearch(options).then((resp) => {
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data, 'Success')
    } else if (resp.code === 10) {
      if (resp.data.guess === undefined) {
        completion(null, 'NotFound')
      } else {
        completion(resp.data, 'Guess')
      }
    }
  }).catch((error) => {
    Indicator.close()
    console.log(error)
  })
}

// 查询区县
function loadCountySearchReq(district, completion) {
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    Toast({
      message: '请检查参数',
      position: 'middle',
      duration: 1000
    })
    return
  }

  var options = {
    openid: JSON.parse(userInfo).openid,
    token: JSON.parse(userInfo).token,
    district: district
  }

  Indicator.open('加载中...')
  Fetch.loadCountySearch(options).then((resp) => {
    Indicator.close()
    if (resp.code === 0) {
      completion(resp.data, 'Success')
    } else if (resp.code === 10) {
      if (resp.data.guess === undefined) {
        completion(null, 'NotFound')
      } else {
        completion(resp.data, 'Guess')
      }
    }
  }).catch((error) => {
    Indicator.close()
    console.log(error)
  })
}

// 搜索
export function search(val, completion) {
  let type = Tool.query('type')
  if (parseInt(type) === 0) { // 小区
    loadCommunitySearchReq(val, function(val, status) {
      completion(val, status, 0)
    })
  } else if (parseInt(type) === 1) { // 商圈
    loadBusinessSearchReq(val, function(val, status) {
      completion(val, status, 1)
    })
  } else if (parseInt(type) === 2) { // 县区
    loadCountySearchReq(val, function(val, status) {
      completion(val, status, 2)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/main/NIMain.js